import React from "react";
import Select from "react-select";

const userRoles = [
  { value: 0, label: "GP" },
  { value: 1, label: "GP Trainee" },
  { value: 2, label: "Nurse" },
  { value: 3, label: "Consultant" },
  { value: 4, label: "NCHD (Hospital Doctor)" },
  { value: 6, label: "Nurse Specialist/ANP" },
  { value: 7, label: "Allied Healthcare Professional" },
  // {value: 8, label: 'IGPNEA Members'}
  { value: 9, label: "Pharmacy" },
  // { value: 11, label: "Midwife" },
  // { value: 12, label: "Registered General Nurse" },
  { value: 11, label: "Industry" },
];

class UserTypeSelectCalendar extends React.Component {
  render() {
    const { value, onChange, errors } = this.props;

    return (
      <div className="col s4">
        <Select
          options={userRoles}
          placeholder="Select your Audience"
          value={value}
          onChange={onChange}
          multi={true}
        />
        <div style={{ color: "red", fontSize: "0.875rem" }}>
          {(errors || []).join(". ")}
        </div>
      </div>
    );
  }
}

export default UserTypeSelectCalendar;



// WEBPACK FOOTER //
// ./src/containers/Calendar/UserTypeSelectCalendar.jsx